import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error(
    'Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. ' +
      'Set them in Cloudflare Pages -> Settings -> Environment variables ' +
      '(Production + Preview) and rebuild.'
  );
}

// PKCE is what Supabase invite + password-recovery emails expect. The Session 2
// bridge to `flowType: 'implicit'` was only for hand-generated admin magic
// links; those aren't used anymore now that invite + reset are wired up.
export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});

export const SITE_URL =
  typeof window !== 'undefined' ? window.location.origin : '';

export const SET_PASSWORD_URL = SITE_URL ? `${SITE_URL}/set-password` : undefined;
